import manager from 'app/module46/component-manager.js';

manager.register('confirmation', (component, elements, attributes, properties) => {
	
	const confirmInput = document.querySelector('input[name=' + component.name + '_confirmation]');
	const confirmField = confirmInput.closest('.form__field');

	const name = component.name;
	const undo = component.value;

	function update() {

		let opacity;

		if(component.value == undo) {
			component.removeAttribute('name');
			confirmInput.removeAttribute('name');
			opacity = 0;
		} else {
			component.setAttribute('name', name);
			confirmInput.setAttribute('name', name + '_confirmation');
			opacity = 1;
		}

		$(confirmField).stop().animate({ 
			opacity
		}, () => {
			confirmInput.disabled = confirmField.style.opacity < 1;
		});
	}

	component.addEventListener('keyup', update);
	component.addEventListener('change', update);

	update();
});
